import {Observable} from 'rxjs';
import {inject, Injectable} from '@angular/core';
import {Notification} from '@store/notifications/notifications.types';
import {ApiService} from '@aviary/services/api.service';
import {contextWithErrorHandlerForMarkNotificationsAsRead} from '@store/notifications/notifications.handlers';

@Injectable({providedIn: 'root'})
export class NotificationsService {

  private readonly apiService: ApiService = inject(ApiService);

  public loadUnreadNotifications(): Observable<Notification[]> {
    const endpoint: string = 'patrons/v3/patrons/notifications';

    return this.apiService.getObjects(endpoint);
  }

  public markNotificationsAsRead(notificationIds: number[]): Observable<void> {
    const endpoint: string = 'patrons/v3/patrons/notifications/mark-read';

    return this.apiService.patch(endpoint, notificationIds, {context: contextWithErrorHandlerForMarkNotificationsAsRead()});
  }
}
